"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _infiniteThinScrollbar = _interopRequireDefault(require("../../common/infinite-thin-scrollbar/infinite-thin-scrollbar"));

var _dashboardGridItem = _interopRequireDefault(require("./dashboard-grid-item/dashboard-grid-item"));

var _dashboardGridItem2 = _interopRequireDefault(require("./dashboard-grid-item.shape"));

var _dashboardGridItemFeature = _interopRequireDefault(require("./dashboard-grid-item/dashboard-grid-item-feature.shape"));

const DashboardGrid = props => {
  const {
    videos,
    onPlay,
    className,
    publishButton,
    actionFeatures,
    onEdit,
    onDuplicate,
    onDelete,
    onPublish,
    loadMore,
    hasMore
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('dashboard-grid', className)
  }, /*#__PURE__*/_react.default.createElement(_infiniteThinScrollbar.default, {
    loadMore: loadMore,
    hasMore: hasMore
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dashboard-grid__inner"
  }, videos.map(video => {
    const {
      id,
      thumbnailUrl,
      ratio,
      title,
      createdDate
    } = video;
    return /*#__PURE__*/_react.default.createElement(_dashboardGridItem.default, {
      thumbnailUrl: thumbnailUrl,
      ratio: ratio,
      title: title,
      createdDate: createdDate,
      onPlay: () => onPlay(video),
      publishButton: publishButton,
      actionFeatures: actionFeatures,
      key: id,
      onEdit: () => onEdit(video),
      onDuplicate: () => onDuplicate(video),
      onDelete: () => onDelete(video),
      onPublish: () => onPublish(video)
    });
  }))));
};

DashboardGrid.propTypes = {
  videos: _propTypes.default.arrayOf(_dashboardGridItem2.default),
  onPlay: _propTypes.default.func.isRequired,
  className: _propTypes.default.string,
  publishButton: _propTypes.default.string,
  actionFeatures: _propTypes.default.arrayOf(_dashboardGridItemFeature.default).isRequired,
  onEdit: _propTypes.default.func,
  onDuplicate: _propTypes.default.func,
  onDelete: _propTypes.default.func.isRequired,
  onPublish: _propTypes.default.func.isRequired,
  loadMore: _propTypes.default.func.isRequired,
  hasMore: _propTypes.default.bool
};
DashboardGrid.defaultProps = {
  videos: [],
  onEdit: null,
  onDuplicate: null,
  className: '',
  publishButton: undefined,
  hasMore: false
};
var _default = DashboardGrid;
exports.default = _default;